import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../supabase';
import AdminNav from '../components/AdminNav';

export default function SurveyResults() {
    const navigate = useNavigate();
    const [responses, setResponses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [username, setUsername] = useState('');
    const [role, setRole] = useState('');
    const [view, setView] = useState('cards'); // 'cards' | 'table'

    useEffect(() => {
        const checkUser = async () => {
            const { data } = await supabase.auth.getSession();
            if (!data.session) {
                navigate('/login');
            }
        };
        checkUser();
    }, [navigate]);

    useEffect(() => {
        const fetchUser = async () => {
            const { data } = await supabase.auth.getSession();
            if (!data.session) return;
            const { data: userData } = await supabase
                .from('users')
                .select('username, role')
                .eq('email', data.session.user.email)
                .single();
            if (userData) { setUsername(userData.username); setRole(userData.role); }
        };
        fetchUser();
    }, []);

    useEffect(() => {
        const fetchResponses = async () => {
            const { data, error } = await supabase
                .from('survey_responses')
                .select('*')
                .order('submitted_at', { ascending: false });
            if (!error) setResponses(data);
            setLoading(false);
        };
        fetchResponses();
    }, []);

    const handleLogout = async () => {
        await supabase.auth.signOut();
        navigate('/login');
    };


    const cellStyle = { padding: '10px 12px', fontSize: '12px', color: '#333', borderBottom: '0.5px solid #e0e0e0', verticalAlign: 'top' };
    const headStyle = { padding: '10px 12px', fontSize: '10px', fontWeight: '500', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#aaa', borderBottom: '0.5px solid #e0e0e0', textAlign: 'left', whiteSpace: 'nowrap' };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>

            {/* Topbar */}
            <AdminNav
                username={username}
                role={role}
                onLogout={handleLogout}
                activePath="/admin/surveys"
            />

            {/* Main */}
            <div style={{ flex: 1, padding: '24px 28px', overflowY: 'auto', background: '#f7f7f7' }}>

                {/* Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <div>
                        <p style={{ fontSize: '10px', fontWeight: '500', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#aaa', margin: '0 0 4px' }}>Admin</p>
                        <h1 style={{ fontWeight: '400', fontSize: '20px', color: '#111', margin: 0 }}>Survey responses</h1>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {/* Toggle view */}
                        <div style={{ display: 'flex', border: '0.5px solid #e0e0e0', borderRadius: '20px', overflow: 'hidden', background: 'white' }}>
                            {['cards', 'table'].map((v) => (
                                <button key={v} onClick={() => setView(v)} style={{ padding: '4px 12px', fontSize: '11px', border: 'none', background: view === v ? '#111' : 'white', color: view === v ? 'white' : '#888', cursor: 'pointer', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>
                                    {v === 'cards' ? '⊞ Cards' : '☰ Table'}
                                </button>
                            ))}
                        </div>
                        <div style={{ background: '#111', color: 'white', borderRadius: '20px', padding: '4px 14px', fontSize: '12px' }}>
                            {responses.length} réponse{responses.length !== 1 ? 's' : ''}
                        </div>
                    </div>
                </div>

                {loading && <div style={{ textAlign: 'center', padding: '60px', color: '#aaa', fontSize: '13px' }}>Chargement...</div>}
                {!loading && responses.length === 0 && <div style={{ textAlign: 'center', padding: '60px', color: '#aaa', fontSize: '13px' }}>Aucune réponse pour l'instant.</div>}

                {/* Cards view */}
                {!loading && view === 'cards' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        {responses.map((r) => (
                            <div key={r.id} style={{ background: 'white', border: '0.5px solid #e0e0e0', borderRadius: '10px', padding: '18px 20px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '14px' }}>
                                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                                        {r.name && <span style={{ fontSize: '13px', fontWeight: '500', color: '#111' }}>{r.name}</span>}
                                        {r.name && <span style={{ color: '#e0e0e0' }}>·</span>}
                                        <span style={{ fontSize: '12px', color: '#555' }}>{r.program || '—'}</span>
                                        <span style={{ color: '#e0e0e0' }}>·</span>
                                        <span style={{ fontSize: '12px', color: '#555' }}>{r.year_of_study || '—'}</span>
                                        {r.lang && <span style={{ fontSize: '10px', color: '#aaa', background: '#f5f5f5', borderRadius: '10px', padding: '2px 8px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{r.lang}</span>}
                                    </div>
                                    <span style={{ fontSize: '11px', color: '#aaa', whiteSpace: 'nowrap', marginLeft: '12px' }}>{new Date(r.submitted_at).toLocaleDateString('fr-CA')}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    {r.biggest_challenge && <div><p style={{ fontSize: '10px', fontWeight: '500', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#aaa', margin: '0 0 3px' }}>Défi</p><p style={{ fontSize: '13px', color: '#333', margin: 0 }}>{r.biggest_challenge}</p></div>}
                                    {r.desired_features && <div><p style={{ fontSize: '10px', fontWeight: '500', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#aaa', margin: '0 0 3px' }}>Fonctionnalités voulues</p><p style={{ fontSize: '13px', color: '#333', margin: 0 }}>{r.desired_features}</p></div>}
                                    {r.tools_used?.length > 0 && (
                                        <div>
                                            <p style={{ fontSize: '10px', fontWeight: '500', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#aaa', margin: '0 0 6px' }}>Outils</p>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                                {r.tools_used.map((tool) => <span key={tool} style={{ fontSize: '11px', padding: '3px 10px', border: '0.5px solid #e0e0e0', borderRadius: '20px', color: '#555' }}>{tool}</span>)}
                                            </div>
                                        </div>
                                    )}
                                    {r.extra_comments && <div><p style={{ fontSize: '10px', fontWeight: '500', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#aaa', margin: '0 0 3px' }}>Commentaires</p><p style={{ fontSize: '13px', color: '#888', margin: 0, fontStyle: 'italic' }}>{r.extra_comments}</p></div>}
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Table view */}
                {!loading && view === 'table' && (
                    <div style={{ background: 'white', border: '0.5px solid #e0e0e0', borderRadius: '10px', overflow: 'hidden' }}>
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                                <thead>
                                    <tr style={{ background: '#fafafa' }}>
                                        <th style={headStyle}>Date</th>
                                        <th style={headStyle}>Nom</th>
                                        <th style={headStyle}>Programme</th>
                                        <th style={headStyle}>Année</th>
                                        <th style={headStyle}>Défi</th>
                                        <th style={headStyle}>Fonctionnalités</th>
                                        <th style={headStyle}>Outils</th>
                                        <th style={headStyle}>Commentaires</th>
                                        <th style={headStyle}>Lang</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {responses.map((r) => (
                                        <tr key={r.id} style={{ background: 'white' }}>
                                            <td style={{ ...cellStyle, whiteSpace: 'nowrap', color: '#aaa' }}>{new Date(r.submitted_at).toLocaleDateString('fr-CA')}</td>
                                            <td style={{ ...cellStyle, fontWeight: '500', color: '#111' }}>{r.name || '—'}</td>
                                            <td style={cellStyle}>{r.program || '—'}</td>
                                            <td style={{ ...cellStyle, whiteSpace: 'nowrap' }}>{r.year_of_study || '—'}</td>
                                            <td style={{ ...cellStyle, maxWidth: '200px' }}>{r.biggest_challenge || '—'}</td>
                                            <td style={{ ...cellStyle, maxWidth: '200px' }}>{r.desired_features || '—'}</td>
                                            <td style={{ ...cellStyle, maxWidth: '160px' }}>{r.tools_used?.join(', ') || '—'}</td>
                                            <td style={{ ...cellStyle, maxWidth: '160px', color: '#888', fontStyle: 'italic' }}>{r.extra_comments || '—'}</td>
                                            <td style={{ ...cellStyle, textTransform: 'uppercase', fontSize: '10px', color: '#aaa' }}>{r.lang || '—'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}